import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'fastCover.tugoTripCancellation.title',
    defaultMessage: 'Changes to your journey',
  },
  sectionIntro: {
    id: 'fastCover.tugoTripCancellation.sectionIntro',
    defaultMessage: 'This section relates to travel expenses such as flights, accommodation, tours, etc.',
  },
  cancelledBeforeLeaving: {
    id: 'fastCover.tugoTripCancellation.cancelledBeforeLeaving',
    defaultMessage: 'Have you cancelled or changed your journey before leaving?',
  },
  changedAfterLeaving: {
    id: 'fastCover.tugoTripCancellation.changedAfterLeaving',
    defaultMessage: 'Have you changed your journey after leaving?',
  },
  introHeading: {
    id: 'fastCover.tugoTripCancellation.introHeading',
    defaultMessage: 'This section relates to expenses incurred as a result of the cancellation of your trip prior to departure.',
  },
  introBody: {
    id: 'fastCover.tugoTripCancellation.introBody',
    defaultMessage: 'Benefits will only be payable if the trip has been cancelled as a result of one of the covered risks listed here and in your policy booklet. Refer to your policy for a description of the benefits applicable to the covered risks, and select the risk that applies to your cancellation reason below. Please also refer to your policy booklet for exclusions and restrictions that may apply to each covered reason.',
  },
  expensesQuestion: {
    id: 'fastCover.tugoTripCancellation.expensesQuestion',
    defaultMessage: 'What type of expenses are you claiming for? Choose all that apply.',
  },
  reasonHealth: {
    id: 'fastCover.tugoTripCancellation.reasonHealth',
    defaultMessage: 'Trip cancellation reasons related to health',
  },
  reasonPregnancyAdoption: {
    id: 'fastCover.tugoTripCancellation.reasonPregnancyAdoption',
    defaultMessage: 'Trip cancellation reasons related to pregnancy and adoption',
  },
  reasonEmploymentEducation: {
    id: 'fastCover.tugoTripCancellation.reasonEmploymentEducation',
    defaultMessage: 'Trip cancellation reasons related to employment and education',
  },
  reasonLegalIssues: {
    id: 'fastCover.tugoTripCancellation.reasonLegalIssues',
    defaultMessage: 'Trip cancellation reasons related to legal issues',
  },
  reasonCarrierAccidentWeather: {
    id: 'fastCover.tugoTripCancellation.reasonCarrierAccidentWeather',
    defaultMessage: 'Trip cancellation reasons related to cancellations and delays by carrier, accident or weather',
  },
  reasonOther: {
    id: 'fastCover.tugoTripCancellation.reasonOther',
    defaultMessage: 'Other reasons for trip cancellation',
  },
  descriptionOfLoss: {
    id: 'fastCover.tugoTripCancellation.descriptionOfLoss',
    defaultMessage: 'Please describe what happened and why the trip was cancelled.',
  },

  // Health sub-questions
  healthRelatedToYouOrTravellingCompanion: {
    id: 'fastCover.tugoTripCancellation.healthRelatedToYouOrTravellingCompanion',
    defaultMessage: 'Is your claim related to a medical condition, death or quarantine of you or your travelling companion?',
  },
  healthRelatedToFamilyMember: {
    id: 'fastCover.tugoTripCancellation.healthRelatedToFamilyMember',
    defaultMessage: "Is your claim related to a medical condition, death or quarantine of your family member or your travelling companion's family member?",
  },
  healthRelatedToBusinessPartnerOrEmployer: {
    id: 'fastCover.tugoTripCancellation.healthRelatedToBusinessPartnerOrEmployer',
    defaultMessage: "Is your claim related to a medical condition or death of your or your travelling companion's business partner, employer or key employee, caregiver, or death of a friend not travelling with you on the trip?",
  },
  healthRelatedToHostAtDestination: {
    id: 'fastCover.tugoTripCancellation.healthRelatedToHostAtDestination',
    defaultMessage: 'Is your claim related to a medical condition, death or quarantine of your host at your destination?',
  },

  // Pregnancy/adoption sub-questions
  pregnancyAdoptionLegalAdoption: {
    id: 'fastCover.tugoTripCancellation.pregnancyAdoptionLegalAdoption',
    defaultMessage: 'Is your claim related to you or your travelling companion being notified that the actual date of a legal adoption of a child by you or your travelling companion is scheduled to take place during your trip?',
  },
  pregnancyAdoptionPregnancyDiagnosed: {
    id: 'fastCover.tugoTripCancellation.pregnancyAdoptionPregnancyDiagnosed',
    defaultMessage: 'Is your claim related to a pregnancy, being diagnosed after the date the trip is booked or after the date this Insurance is purchased?',
  },
  pregnancyAdoptionComplicationsOfPregnancy: {
    id: 'fastCover.tugoTripCancellation.pregnancyAdoptionComplicationsOfPregnancy',
    defaultMessage: 'Is your claim related to complications of a pregnancy, occurring within the first 31 weeks of pregnancy?',
  },

  // Employment/education sub-questions
  employmentEducationJobTransfer: {
    id: 'fastCover.tugoTripCancellation.employmentEducationJobTransfer',
    defaultMessage: "Is your claim related to you, your spouse or your travelling companion's job transfer which results in the relocation of your or your travelling companion's principal residence?",
  },
  employmentEducationInvoluntaryLossOfEmployment: {
    id: 'fastCover.tugoTripCancellation.employmentEducationInvoluntaryLossOfEmployment',
    defaultMessage: "Is your claim related to involuntary loss of your, your spouse's, your travelling companion's or your travelling companion's spouse's permanent employment (excluding contract or self-employment)?",
  },
  employmentEducationCancellationOfBusinessMeeting: {
    id: 'fastCover.tugoTripCancellation.employmentEducationCancellationOfBusinessMeeting',
    defaultMessage: 'Is your claim for costs directly related to cancellation of a business meeting at your destination beyond your, your travelling companion, or the employer\'s control?',
  },
  employmentEducationCancellationOfConference: {
    id: 'fastCover.tugoTripCancellation.employmentEducationCancellationOfConference',
    defaultMessage: "Is your claim related to the cancellation of a conference, seminar, workshop, convention, symposium or retreat at your or your travelling companion's destination that is beyond your or your travelling companion's control?",
  },

  // Legal issues sub-questions
  legalIssuesCanadianGovernmentAdvisory: {
    id: 'fastCover.tugoTripCancellation.legalIssuesCanadianGovernmentAdvisory',
    defaultMessage: 'Is your claim related to a Canadian government issuing an advisory stating that travel to your destination will require self-quarantine or self-isolation upon your return to the province/territory you are staying in in Canada?',
  },
  legalIssuesJuryDutyCourtProceeding: {
    id: 'fastCover.tugoTripCancellation.legalIssuesJuryDutyCourtProceeding',
    defaultMessage: 'Is your claim related to you or your travelling companion being subpoenaed for jury duty, as a witness, or being required to appear at a court proceeding during the period of travel?',
  },
  legalIssuesSummonedToService: {
    id: 'fastCover.tugoTripCancellation.legalIssuesSummonedToService',
    defaultMessage: 'Is your claim related to You or your travelling companion being summoned to police, fire, paramedic or military service (active or reserve)?',
  },
  legalIssuesOfficialTravelAdvisory: {
    id: 'fastCover.tugoTripCancellation.legalIssuesOfficialTravelAdvisory',
    defaultMessage: 'Is your cancellation claim related to an official travel advisory being issued by a Canadian Government stating to "avoid all travel" or "avoid non-essential travel" to any of your travel destinations including any stopovers, layovers or any other destinations you are transiting through? This reason may also apply to visitors entering Canada, or if travel is restricted within Canada. Travel restriction must remain in effect within the 7 days before your departure date.',
  },
  legalIssuesNonIssuanceOfVisa: {
    id: 'fastCover.tugoTripCancellation.legalIssuesNonIssuanceOfVisa',
    defaultMessage: "Is your claim related to the non-issuance of your or your travelling companion's travel or student visa (not including an immigration or employment visa) for reasons beyond your or your travelling companion's control?",
  },

  // Carrier/accident/weather sub-questions
  carrierMissedConnection: {
    id: 'fastCover.tugoTripCancellation.carrierMissedConnection',
    defaultMessage: "Is your claim related to the earlier departure, the later departure or the later arrival of your or your travelling companion's common carrier causing a missed connection?",
  },
  carrierFourHoursNoConnection: {
    id: 'fastCover.tugoTripCancellation.carrierFourHoursNoConnection',
    defaultMessage: "Is your claim related to the earlier departure, the later departure or the later arrival of your or your travelling companion's common carrier by at least 4 hours when there is no connection?",
  },
  carrierCancellationOfCommonCarrier: {
    id: 'fastCover.tugoTripCancellation.carrierCancellationOfCommonCarrier',
    defaultMessage: 'Is your claim related to the cancellation of a common carrier for any reason other than bankruptcy, insolvency or quarantine?',
  },
  carrierTourOperatorCancellation: {
    id: 'fastCover.tugoTripCancellation.carrierTourOperatorCancellation',
    defaultMessage: "Is your claim related to the cancellation of your or your travelling companion's tour by the tour operator?",
  },
  carrierAccidentOnWay: {
    id: 'fastCover.tugoTripCancellation.carrierAccidentOnWay',
    defaultMessage: 'Is your claim related to an accident on the way to the departure point involving a private vehicle in which you are a passenger or driver; or a common carrier in which you are a passenger?',
  },
  carrierDelayOfPrivateVehicle: {
    id: 'fastCover.tugoTripCancellation.carrierDelayOfPrivateVehicle',
    defaultMessage: 'Is your claim related to the delay of a private vehicle resulting from mechanical failure of the vehicle, weather conditions, earthquakes, volcanic eruptions, a traffic accident, or an emergency police-directed road closure?',
  },

  // Other reasons sub-questions
  otherReasonsNaturalDisaster: {
    id: 'fastCover.tugoTripCancellation.otherReasonsNaturalDisaster',
    defaultMessage: "Is your claim related to a natural disaster, which renders your or your travelling companion's principal residence uninhabitable or place of business inoperative?",
  },
  otherReasonsUnforeseeableEvent: {
    id: 'fastCover.tugoTripCancellation.otherReasonsUnforeseeableEvent',
    defaultMessage: "Is your claim related to an unforeseeable event completely independent of any intentional or negligent act which renders your or your travelling companion's principal residence uninhabitable or place of business inoperative?",
  },
  otherReasonsCfar: {
    id: 'fastCover.tugoTripCancellation.otherReasonsCfar',
    defaultMessage: 'Is your claim related to a reason not listed above?',
  },

  // Expense category labels
  nonRefundablePrePaidTravelCosts: {
    id: 'fastCover.tugoTripCancellation.nonRefundablePrePaidTravelCosts',
    defaultMessage: 'Non-Refundable Pre-paid travel costs (other than transportation)',
  },
  nonRefundablePrePaidTransportationCosts: {
    id: 'fastCover.tugoTripCancellation.nonRefundablePrePaidTransportationCosts',
    defaultMessage: 'Non-Refundable Pre-paid transportation costs',
  },
  commercialAccommodationToResumeTravel: {
    id: 'fastCover.tugoTripCancellation.commercialAccommodationToResumeTravel',
    defaultMessage: 'Commercial Accommodation to resume travel',
  },
  changeFeesIfCancellingPortionOfTrip: {
    id: 'fastCover.tugoTripCancellation.changeFeesIfCancellingPortionOfTrip',
    defaultMessage: 'Change Fees if cancelling portion of trip',
  },
  changeFeesSelectOnlyOne: {
    id: 'fastCover.tugoTripCancellation.changeFeesSelectOnlyOne',
    defaultMessage: ' - Select only one of the following',
  },
  changeFeesPortionOfTrip: {
    id: 'fastCover.tugoTripCancellation.changeFeesPortionOfTrip',
    defaultMessage: 'Change fees - portion of trip',
  },
  oneWayAirfarePortionOfTrip: {
    id: 'fastCover.tugoTripCancellation.oneWayAirfarePortionOfTrip',
    defaultMessage: 'One way airfare - portion of trip',
  },
  singleSupplement: {
    id: 'fastCover.tugoTripCancellation.singleSupplement',
    defaultMessage: 'Single Supplement',
  },
  nonRefundablePrePaidTourCosts: {
    id: 'fastCover.tugoTripCancellation.nonRefundablePrePaidTourCosts',
    defaultMessage: 'Non-Refundable Pre-paid tour costs',
  },
  nonRefundablePrePaidTransportationCostsNotPartOfTour: {
    id: 'fastCover.tugoTripCancellation.nonRefundablePrePaidTransportationCostsNotPartOfTour',
    defaultMessage: 'Non-Refundable Pre-paid transportation costs that is not part of the tour',
  },

  // Tooltip texts
  tooltipCommercialAccommodation: {
    id: 'fastCover.tugoTripCancellation.tooltipCommercialAccommodation',
    defaultMessage: 'This benefit only applies when you choose to cancel a portion of your trip',
  },
  tooltipChangeFeesPortionOfTrip: {
    id: 'fastCover.tugoTripCancellation.tooltipChangeFeesPortionOfTrip',
    defaultMessage: 'This benefit only applies when you choose to cancel a portion of your trip. This cannot be claimed in combination with a one-way fare to resume your travel.',
  },
  tooltipOneWayAirfarePortionOfTrip: {
    id: 'fastCover.tugoTripCancellation.tooltipOneWayAirfarePortionOfTrip',
    defaultMessage: 'This benefit only applies when your travelling companion cancels their trip and additional costs are charged to change your commercial accommodation to single',
  },

  // Expense form field labels
  expenseFor: {
    id: 'fastCover.tugoTripCancellation.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.tugoTripCancellation.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  descriptionOfExpense: {
    id: 'fastCover.tugoTripCancellation.descriptionOfExpense',
    defaultMessage: 'Description of expense',
  },
  dateOfExpense: {
    id: 'fastCover.tugoTripCancellation.dateOfExpense',
    defaultMessage: 'Date of expense',
  },
  amountClaimed: {
    id: 'fastCover.tugoTripCancellation.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  currency: {
    id: 'fastCover.tugoTripCancellation.currency',
    defaultMessage: 'Currency',
  },
  providerName: {
    id: 'fastCover.tugoTripCancellation.providerName',
    defaultMessage: 'Provider Name',
  },

  // Common
  isRequired: {
    id: 'fastCover.tugoTripCancellation.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  checkEventDate: {
    id: 'fastCover.tugoTripCancellation.checkEventDate',
    defaultMessage: '\'{defaultMessage}\' is not a valid date',
  },
  addItem: {
    id: 'fastCover.tugoTripCancellation.addItem',
    defaultMessage: 'Add Expense',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripCancellationTraveller/messages.js